/**
 * Duration formatting.
 *
 * The spec asks for "Xh Ym" everywhere — entry lists, day totals, calendar cells — so every
 * place that renders a duration goes through here rather than formatting inline.
 * Mirrors api/app/services/duration.py.
 */

export const MINUTES_PER_HOUR = 60;

export function splitDuration(totalMinutes: number): { hours: number; minutes: number } {
  const safe = Math.max(0, Math.round(totalMinutes));
  return {
    hours: Math.floor(safe / MINUTES_PER_HOUR),
    minutes: safe % MINUTES_PER_HOUR,
  };
}

export function formatDuration(totalMinutes: number): string {
  const { hours, minutes } = splitDuration(totalMinutes);
  return `${hours}h ${minutes}m`;
}

/** Compact form for calendar cells, where "0h 0m" is just noise. */
export function formatDurationShort(totalMinutes: number): string {
  if (totalMinutes <= 0) return "";
  const { hours, minutes } = splitDuration(totalMinutes);
  if (minutes === 0) return `${hours}h`;
  if (hours === 0) return `${minutes}m`;
  return `${hours}h ${minutes}m`;
}
